import React from 'react';
import styles from './styles.module.css';
import BannerCta from '@/components/general/BannerCta';
import SectionHead from '@/components/general/SectionHead';
import ConfirmationButton from '@/components/common/ConfirmationButton';
import MainIcons from '@/icons/main';

export default function AboutUsBanner() {
  return (
    <BannerCta className={`${styles.bannercta}`} glowClass={styles.glowClass}>
      <SectionHead
        title="به خانوادهٔ کارا بپیوندید"
        text="همین حالا شروع کنید و مدیریت هوشمند خودروی خود را تجربه کنید."
        headingTag="div"
        position="center"
        type="accountHero"
      />
      <ConfirmationButton
        rejectText={
          <>
            شروع کنید
            <MainIcons.arrowLongIcon
              fill="var(--paper)"
              className={`${'rotateIcon-rtl'}`}
              width="14px"
              height="14px"
            />
          </>
        }
        confirmText="تماس با ما"
        className={`${styles.buttonsContainer}`}
        confirmType="link"
        confirmHref="/contactUs"
        buttonsClass={`${styles.buttonsClass}`}
        extraConfirmStyle="squareButton"
        extraRejectStyle={`squareButton`}
      />
    </BannerCta>
  );
}
